import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight, faCode, faSearch, faFile, faServer, faClock, faTicketAlt, faList, faRocket, faPlus } from '@fortawesome/free-solid-svg-icons';

const TOOL_ICONS: Record<string, any> = {
  list_validations: faList,
  create_validation: faRocket,
  get_workspace_context: faServer,
  read_workspace_file: faFile,
  search_workspace_code: faSearch,
  get_app_status: faServer,
  get_activity_timeline: faClock,
  list_tickets: faTicketAlt,
  create_ticket: faPlus,
};

const TOOL_LABELS: Record<string, string> = {
  list_validations: 'Listing workspaces',
  create_validation: 'Creating agent workspace',
  get_workspace_context: 'Getting workspace context',
  read_workspace_file: 'Reading file',
  search_workspace_code: 'Searching code',
  get_app_status: 'Checking app status',
  get_activity_timeline: 'Loading activity',
  list_tickets: 'Listing tickets',
  create_ticket: 'Creating ticket',
};

interface Props {
  tool: string;
  args: Record<string, any>;
  result?: string;
}

const ToolCallCard: React.FC<Props> = ({ tool, args, result }) => {
  const [expanded, setExpanded] = useState(false);
  const icon = TOOL_ICONS[tool] || faCode;
  const label = TOOL_LABELS[tool] || tool;

  const argSummary = Object.entries(args)
    .filter(([k]) => k !== 'validationId')
    .map(([k, v]) => `${k}: ${typeof v === 'string' ? v : JSON.stringify(v)}`)
    .join(', ');

  return (
    <div className="border border-gray-200 rounded-lg my-2 overflow-hidden bg-gray-50">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center gap-2 px-3 py-2 text-left text-sm hover:bg-gray-100 transition-colors"
      >
        <FontAwesomeIcon
          icon={expanded ? faChevronDown : faChevronRight}
          className="text-gray-400 w-3"
        />
        <FontAwesomeIcon icon={icon} className="text-indigo-500 w-4" />
        <span className="font-medium text-gray-700">{label}</span>
        {argSummary && (
          <span className="text-gray-400 text-xs truncate ml-1">
            ({argSummary.slice(0, 60)}{argSummary.length > 60 ? '...' : ''})
          </span>
        )}
        {result && (
          <span className="ml-auto text-xs text-green-600 font-medium">Done</span>
        )}
      </button>

      {expanded && (
        <div className="border-t border-gray-200 px-3 py-2 space-y-2">
          <div>
            <div className="text-xs font-medium text-gray-500 mb-1">Arguments</div>
            <pre className="text-xs bg-white p-2 rounded border border-gray-100 overflow-x-auto max-h-32">
              {JSON.stringify(args, null, 2)}
            </pre>
          </div>
          {result && (
            <div>
              <div className="text-xs font-medium text-gray-500 mb-1">Result</div>
              <pre className="text-xs bg-white p-2 rounded border border-gray-100 overflow-x-auto max-h-48 whitespace-pre-wrap">
                {result.slice(0, 2000)}
                {result.length > 2000 ? '\n... (truncated)' : ''}
              </pre>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ToolCallCard;
